import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setToken } from '../api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try {
      const { token } = await api.login(email, password);
      setToken(token);
      navigate('/crm');
    } catch {
      setErr('Invalid email or password.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="apply-shell">
      <form className="apply-card login" onSubmit={submit}>
        <div className="brand-mark small"><img src="/brand.jpg" alt="" onError={e => { e.target.style.display = 'none'; e.target.parentElement.classList.add('text-fallback'); e.target.parentElement.textContent = 'LHAI'; }} /></div>
        <h1 className="brand-title">CRM Login</h1>
        <p className="brand-tagline">Layah Heilpern AI Automation</p>

        <input
          className="text-input"
          type="email"
          placeholder="Email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          autoFocus
          required
        />
        <input
          className="text-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
          style={{ marginTop: 12 }}
        />
        {err && <div className="error-msg">{err}</div>}
        <button className="btn-primary" type="submit" disabled={busy} style={{ marginTop: 20 }}>
          {busy ? 'Signing in...' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
